<template>
  <div class="vet-notes-container">
    <div class="vet-notes">
      <span class="form-group">
        <label>Notes to self</label>
        <vet-notes-toggle style="float: right">
          <i class="glyphicon glyphicon-remove" v-tooltip="'Hide vet notes'"> </i>
        </vet-notes-toggle>
        <br />
        <small class="form-text text-muted"> (These notes are emailed to the consulting vet on submit) </small>
      </span>
      <textarea
        type="text"
        v-model="currentCommentValue"
        class="form-control"
        placeholder="Enter notes here"
        :disabled="isReadOnly"
        @input="resizeTextarea"
        ref="resizabletextarea"
      >
      </textarea>
      <div v-if="lastYearCommentValue">
        <dl class="previous-years-comments" >
          <dt>
            Previous years notes
            <i :class="showPreviousYear ? 'glyphicon glyphicon-eye-open' : 'glyphicon glyphicon-eye-close'" @click="showPreviousYear = !showPreviousYear"> </i>
          </dt>
          <dd class="text-block" v-html="lastYearCommentValue" v-show="showPreviousYear"></dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import VetNotesToggle from '@/components/VetNotesToggle'

export default {
  name: 'VetNotes',
  components: {
    VetNotesToggle,
  },
  data() {
    return {
      showPreviousYear: false
    }
  },
  props: {
    emailNotification: {
      type: String,
    },
    fieldName: {
      type: String,
      required: true,
    },
    modelName: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.resizeTextarea()
  },
  methods: {
    ...mapMutations('currentConsult', ['setEmailNotification']),
    resizeTextarea() {
      let textarea = this.$refs.resizabletextarea
      let viewportMargin = 400
      let maxHeight =
        textarea.scrollHeight > visualViewport.height - viewportMargin
          ? visualViewport.height - viewportMargin
          : textarea.scrollHeight
      this.$nextTick(() => {
        textarea.style.height = 'auto'
        textarea.style.height = `${maxHeight}px`
      })
    },
  },
  computed: {
    ...mapState('currentConsult', ['showVetNotes']),
    ...mapGetters('currentConsult', ['isReadOnly', 'getFieldComment']),
    lastYearCommentValue() {
      return this.getFieldComment(this.fieldName, this.modelName).lastYear
    },
    currentCommentValue: {
      get() {
        return this.getFieldComment(this.fieldName, this.modelName).current
      },
      set(val) {
        let payload = { fieldName: this.fieldName, modelName: this.modelName, value: val }

        this.$store.dispatch('currentConsult/setFieldComment', payload)
        if (this.emailNotification && this.setEmailNotification) {
          this.setEmailNotification({
            slug: this.emailNotification,
            value: Boolean(val),
          })
        }
      },
    },
  },
}
</script>
<style>
.vet-notes textarea {
  min-height: 200px;
}

.vet-notes-container {
  z-index: 3;
}
</style>
